module.exports = __webpack_public_path__ + "img/dont-just-play-right.454a5bf7.png";